import React from 'react';
export function Footer() {
  return <footer className="bg-brand-text text-brand-card py-12 px-4 text-center border-t border-brand-text/10" data-id="element-46">
      <div className="max-w-7xl mx-auto flex flex-col items-center gap-4" data-id="element-47">
        <h3 className="font-serif text-3xl mb-2 text-brand-alt-bg" data-id="element-48">
          Arte en Tricotín
        </h3>
        <p className="text-brand-card/60 text-sm uppercase tracking-widest font-medium" data-id="element-49">
          Producto digital · Descarga inmediata
        </p>
        <div className="w-12 h-px bg-brand-card/20 my-4" data-id="element-50" />
        <p className="text-brand-card/40 text-xs" data-id="element-51">
          © {new Date().getFullYear()} Arte en Tricotín. Todos los derechos
          reservados.
        </p>
      </div>
    </footer>;
}